import React from 'react'
import type { PublicProfileProduct } from 'apollo-gql'

import ProfileCard from 'components/ProfileCard/ProfileCard'

import styles from './ProfileProductGrid.module.css'

type ProfileProductGridProps = {
  profileProducts?: PublicProfileProduct[]
  collectionSlug?: string
}

const ProfileProductGrid: React.FC<ProfileProductGridProps> = ({
  profileProducts = [],
  collectionSlug,
}) => {
  if (!profileProducts.length) return null

  return (
    <section className={styles.profileCardGrid}>
      {profileProducts.map((profileProduct, index) => (
        <div key={profileProduct.id} className="profile-card-grid__item">
          <ProfileCard
            indexPositionInCollection={index}
            startIndexPositionInCollection={1}
            profileProduct={profileProduct}
            collectionSlug={collectionSlug}
          />
        </div>
      ))}
    </section>
  )
}

export default ProfileProductGrid
